import axios from "axios";
import qs from "qs";
const initialState = {
    investments: [],
};

export const state = { ...initialState };

export const actions = {
    async getInvestments (context) {
        return axios.get("/api/investment").then(function(response){
            console.log(response.data);
            context.commit("setInvestments",response.data)
        });
    },
}

export const mutations = {
    setInvestments(state,investments){
        state.investments = investments;
    },
}

const getters = {
    investments(state){
        return state.investments;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
  };
  